module.exports = __webpack_public_path__ + "img/w3_user_light.45931965.png";